class PrestigeCartAttributeProvider extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.cartAttributeName = this.getAttribute('name');
    this.cartAttributeValue = this.getAttribute('value');
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.handleSubmit();
      return false;
    });
  }

  async handleSubmit() {

    await this.setCartAttribute({
      [this.cartAttributeName]: this.cartAttributeValue,
    });

    this.form.submit();

    return;
  }

  async setCartAttribute(attributes) {
    if (!attributes || typeof attributes !== 'object') {
      return;
    }

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ attributes }),
    });

    if (!response.ok) {
      throw new Error(`Failed to update cart: ${response.status} ${response.statusText}`);
    }

    return response;
  }
}
customElements.define('prestige-cart-attribute-provider', PrestigeCartAttributeProvider)
